<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">

					<el-form-item label="键值" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.typeKey" placeholder="请输入键值">
						</el-input>
					</el-form-item>

					<el-form-item label="类型名称" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.typeName" placeholder="请输入类型名称">
						</el-input>
					</el-form-item>

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
						</template>
					</el-form-item>

					<el-form-item>
						<template>
							<el-button type="primary" @click="editDialogVisible = true;advertising={};type=0">新增类型
							</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>

		<el-table :data="advertisingTypeList.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

			<el-table-column prop="typeKey" label="键 值" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="typeName" label="类型名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="typeRemark" label="类型备注" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editFind(scope.row.id)">编 辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删 除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="advertisingTypeList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="advertisingTypeList.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<!-- 编辑 -->
		<el-dialog style="float:rigin" :title="type==0 ? '新增':'编辑'" :visible.sync="editDialogVisible" width="500px"
			:close-on-click-modal="false">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<el-form-item label-width="100px" label="键值:" >
						<el-input v-if="type == 0" type="text" v-model="advertising.typeKey" placeholder="请输入键值" style="width: 300px;"/>
						<div v-else>{{advertising.typeKey}}</div>
					</el-form-item>

					<el-form-item label-width="100px" label="类型名称" >
						<el-input type="text" v-model="advertising.typeName" placeholder="请输入类型名称" style="width: 300px;"/>
					</el-form-item>
					<el-form-item label-width="100px" label="类型备注:" >
						<el-input type="text" v-model="advertising.typeRemark" placeholder="请输入类型备注" style="width: 300px;"/>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="editDialogVisible = false">取 消</el-button>
				<el-button v-if="type == 1" type="primary" @click="edit" :loading="editLoading">确 认</el-button>
				<el-button v-if="type == 0" type="primary" @click="add" :loading="addLoading">添 加</el-button>
				
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				type: 0,
				loading: false,
				advertisingTypeList: [], //广告类型
				advertising: {},
				dialogVisible: false,
				editDialogVisible: false,
				mainFormRules: {
					title: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
				},
				ids: '', //id
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				index: null,
				contentValue: "",
				showContentDialog: false,

				editLoading: false,
				addLoading: false,
			};
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		methods: {
			add() {
				this.addLoading = true;
				this.$api.addAdvertisingType(this.advertising).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false;
						this.findAdvertisingTypeList();
					} else {
						this.$message.error(res.message);
					}
					this.addLoading = false;
				})

			},
			editFind(e) {
				this.type = 1
				this.advertising = {};
				this.editDialogVisible = true;

				this.$api.findAdvertisingTypeById(e).then((res) => { //根据id查询广告类型
					if (res.state == 'success') {
						this.advertising = res.data
					}
				})
			},
			edit() {
				this.editLoading = true;
				this.$api.editAdvertisingType(this.advertising).then((res) => {
					// console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false;
						this.findAdvertisingTypeList();
					} else {
						this.$message.error(res.message);
					}
					this.editLoading = false;
				})
			},
			handleRemove(file, fileList) {
				//console.log(file, fileList);
			},
			handlePreview(file) {
				//console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			onSuccess(response, file, fileList) {
				console.log(response);
				var form = {
					id: this.form.id,
					code: this.form.code,
					typeName: this.form.typeName,
					typeNameEn: this.form.typeNameEn,
					typeImg: response.data
				}
				this.form = form;
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.loading = true
				let webData = {
					pageNum: 1,
					pageSize: this.page.pageSize,
					typeKey: this.searchInfo.typeKey,
					typeName: this.searchInfo.typeName
				}
				console.log(webData)
				this.$api.findAdvertisingTypeList(webData).then((res) => { //广告类型列表
					if (res.state == 'success') {
						this.advertisingTypeList = res.data
					}
					this.loading = false
				})
			},
			showContent(content) {
				this.contentValue = content
				this.showContentDialog = true
			},
			//编辑弹框
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartStartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.startDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.endDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findAdvertisingTypeList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findAdvertisingTypeList()
			},
			findAdvertisingTypeList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize
				}
				this.$api.findAdvertisingTypeList(data).then((res) => { //广告类型列表
					if (res.state == 'success') {
						this.advertisingTypeList = res.data
						this.loading = false
					}
				})
			},
			//删除
			toDelete(id) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delAdvertisingType(id).then((res) => {
						console.log('res', res)
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findAdvertisingTypeList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		},
		created() {
			this.findAdvertisingTypeList();

		},
		mounted: function () { },
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>